export const clockIcon = [
    `512 512`,
    `<g>
        <title>clock icon</title>
        <polygon fill="var(--ci-primary-color, currentColor)" points="271.514 95.5 239.514 95.5 239.514 273.611 355.127 328.559 368.864 299.657 271.514 253.389 271.514 95.5" class="ci-primary"/>
        <path fill="var(--ci-primary-color, currentColor)" d="M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16Zm0,448C141.125,464,48,370.875,48,256S141.125,48,256,48s208,93.125,208,208S370.875,464,256,464Z" class="ci-primary"/>
    </g>`
]